import enUS from "date-fns/locale/en-US" // fallback

import { LanguageInfo } from "../../records/LanguageInfo"
import { Translations, Translate } from "../services/translate"
// eslint-disable-next-line import/no-restricted-paths
import langInfo from "../../../mocks/records/languageInfo"

// @ts-expect-error: Flow to TS migration.
type Record<T, V> = Partial<Record<T, V>>

export type IntlRaw = {
  language: LanguageInfo
  /**
   * @deprecated use `react-intl` instead
   */
  translations: Translations
}

export type Intl = IntlRaw & {
  /**
   * @deprecated use `react-intl`'s `formatMessage` instead
   */
  translate: Translate
  getLocale: Promise<typeof enUS>
}

// @ts-expect-error: Flow to TS migration.
export type IntlsRaw = Record<string, IntlRaw>
// @ts-expect-error: Flow to TS migration.
export type Intls = Record<string, Intl>

export const intlDefault: Intl = {
  language: langInfo,
  translations: {},
  translate: (id) => id,
  getLocale: Promise.resolve(enUS),
}
